export interface PusherStatsResponse {
  playersCount: number;
  distributedPricePool: number;
  prizePool: number;
  placedBets: number;
}

export interface PusherConfigResponse {
  prizePool: number;
  betLimitResetTimestamp: number;
  betSize: number;
  winChance: number;
  remainingBetLimit: number;
  seasonPointsMultiplier: number;
}

export interface PusherGameResultResponse {
  isWinner: boolean;
  winAmount: number;
  seasonPoints: number;
  tokenAddress: string;
}

export enum PusherAnimations {
  Idle = 'pusherIdle',
  BeforeResult = 'pusherBeforeResult',
  Await = 'pusherAwait',
  Win = 'pusherWin',
  Lose = 'pusherLose'
}

export enum PusherGameStatus {
  Idle = 'gameStatusIdle',
  Launched = 'launched',
  Finished = 'finished'
}

export enum PusherTabs {
  SelectGame,
  SelectToken,
  PlaceBet,
  Stats,
  BetSelection,
  Pusher,
  Result,
  Winners,
  Info
}

export interface PusherUsersStatsItem {
  id: number;
  isWinner: boolean;
  betAmount: number;
  tokenAmount: number;
  tokenAddress: string;
  winAmount: number | null;
  userAddress: string;
  userName: string;
  userAvatarUrl: string;
  dateTime: string;
}

export interface PusherUsersStatsResponse {
  total: number;
  count: number;
  pageNumber: number;
  totalPages: number;
  items: PusherUsersStatsItem[];
}
